import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AllTicketsHeader from './AllTicketsHeader';
import { dataAlumnos, updateAverageEscrito, updateAverageGeneral, updateAverageOral } from 'data/apiConection.js/dataAlumnos';
import { columnsAlumnos } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCursos } from 'data/apiConection.js/dataCursos';
import { getUsers } from 'data/apiConection.js/dataUsers';

const TableView = () => {
  const [alumnos, setAlumnos] = useState([]);
  const [flagUpdate, setFlagUpdate] = useState(false);
  const [cursos, setCursos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const user = await getUsers();
      try {
        const cu = await dataCursos();
        if (user.role === 'teacher') {
          const cuByProfesor = cu.filter(curso => curso.profesor_id === user.profesor_id);
          setCursos(cuByProfesor);
        } else {
          setCursos(cu);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await updateAverageEscrito();
        await updateAverageOral();
        await updateAverageGeneral();
        const al = await dataAlumnos();
        setAlumnos(al);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, [flagUpdate]);
  const columns = columnsAlumnos(flagUpdate, setFlagUpdate, cursos);

  return (
    <Row className="gx-0 mx-0" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {alumnos && (
        <Col xxl={12} xl={12} style={{ height: '100%' }}>
          <AdvanceTableWrapper
            columns={columns}
            data={alumnos}
            selection
            selectionColumnWidth={52}
            sortable
            pagination
            perPage={100}
            rowCount={alumnos.length}
          >
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Card.Header className="border-bottom border-200 px-0">
                <AllTicketsHeader title="Alumnos" table layout="table-view" cursos={cursos} alumnos={alumnos} />
              </Card.Header>
              <Card.Body className="p-0" style={{ flexGrow: 1, overflowY: 'auto' }}>
                <AdvanceTable
                  table
                  headerClassName="bg-light text-800 align-middle"
                  rowClassName="btn-reveal-trigger align-middle"
                  tableProps={{
                    size: 'sm',
                    className: 'fs--1 mb-0 w-100 h-100'
                  }}
                />
              </Card.Body>
              <Card.Footer>
                <AdvanceTablePagination table />
              </Card.Footer>
            </Card>
          </AdvanceTableWrapper>
        </Col>
      )}
    </Row>
  );
};

export default TableView;

